import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { AllProductsResponseModel, ProductDto, ProductResponseModel } from '@gtpl/shared-models/masters';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { Injectable, Req } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { Repository } from 'typeorm';
import { UserRequestDto } from '../currencies/dto/user-logs-dto';
import { ProductAdapter } from './dto/product.adapter';
import { ProductDTO } from './dto/product.dto';
import { ProductRequest } from './dto/product.request';
import { Product } from './product.entity';

@Injectable()
export class ProductsService {
    constructor(
      private logService:LogsService,
        @InjectRepository(Product) private productRepository: Repository<Product>,
        private productAdapter: ProductAdapter,
      ) { }

      async createProduct(productDto:ProductDTO,isUpdate:boolean=false,@Req() request:Request): Promise<ProductResponseModel> {
        try {
            let previousValue
        console.log('Product Details' + productDto);
        if (!isUpdate) {
        const productEntity = await this.productRepository.findOne({
            where: {
                productName: productDto.productName,
                
            }
        });

    if (productEntity) {
        throw new ErrorResponse(11104, 'This variant already exists');
    }
}
        else{
            const certificatePrevious = await this.productRepository.findOne({
        where:{productId:productDto.productId}
    });

    previousValue = certificatePrevious?.productName;

    const productEntity = await this.productRepository.findOne({
        where: {
            productName: productDto.productName,
            
        }
    });

    if(productEntity && productEntity.productId != productDto.productId){
        throw new ErrorResponse(11104, 'This variant already exists');
    }
}
        const productEntity: Product = this.productAdapter.convertDtoToEntity(productDto,isUpdate);
        console.log(productEntity);
        const savedProductEntity: Product = await this.productRepository.save(productEntity);
        const savedProductDto: ProductDTO = this.productAdapter.convertEntityToDto(savedProductEntity);
       
         if (savedProductDto) {
            const present = savedProductDto.productName
          const response = new ProductResponseModel(true,isUpdate ? 11100 : 11101,isUpdate? 'Product Updated Successfully':'Product Created Successfully',savedProductDto);
          const name=isUpdate?'updated':'created'
          const displayValue = isUpdate? 'Product Updated Successfully': 'Product Created Successfully'
            const userName = isUpdate? savedProductDto.updatedUser :savedProductDto.createdUser;
            const newLogDto = new LogsDto(1,name, 'Product', savedProductDto.productId, true, displayValue,userName,previousValue,present)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
          return response;
        } else {
          throw new ProductResponseModel(false,11106,'Product saved but issue while transforming into DTO');
        }
      }
      catch (error) {
        throw error;
      }
    }

    /**
     * gets all  val addition one types details  
     * @returns all the val addition one type details .
     */
    async getAllProducts(req?:UserRequestDto): Promise<AllProductsResponseModel> { 
        try {
            const productDto: ProductDto[] = [];
            // retrieves all plants
            const productEntities: Product[] = await this.productRepository.find({
                order: { productName: "ASC" },
            });
            if (productEntities.length>0) {
                productEntities.forEach(productEntity => {
                const convertedProductDto: ProductDto = this.productAdapter.convertEntityToDto(productEntity);
                productDto.push(convertedProductDto);
                });
                const response = new AllProductsResponseModel(true, 11208, "Products retrieved successfully", productDto);
                if(req?.createdUser){
                const newLogDto = new LogsDto(1,'view', 'Product', 0, true, 'Products retrieved successfully',req.createdUser,"",'')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
                }

                return response;
            } else {
                throw new ProductResponseModel(false,99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }
    async getAllActiveProducts(): Promise<AllProductsResponseModel> {
        // const page: number = 1;
        try {
            const productDto: ProductDTO[] = [];
            //retrieves all companies
            const ProductsEntities: Product[] = await this.productRepository.find({ order: { productName: 'ASC' },where:{isActive:true},
           });
         console.log(ProductsEntities)
            if (ProductsEntities) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                ProductsEntities.forEach(productEntity => {
                    const convertedproductDto: ProductDTO = this.productAdapter.convertEntityToDto(
                      productEntity
                    );
                    productDto.push(convertedproductDto);
                });
                const response = new AllProductsResponseModel(true, 11108, "Products retrieved successfully", productDto);
                const newLogDto = new LogsDto(1,'view all active', 'Product', 0, true, '','','','')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
                return response;
            } else {
                throw new ProductResponseModel(false,99998, 'Data not found'); productDto
            }
        } catch (err) {
            throw err;
        }
    }

    async getProduct(productCode: string): Promise<Product> {
        //  console.log(employeeId);
            const response = await this.productRepository.findOne({
            where: {productCode: productCode},
            });
            // console.log(response);
            if (response) {
            return response;
            } else {
            return null;
            }
        }

    /**
     * It deactivates value addition value  type 
     * @param foodTypeRequest addition  type  as string
     * @returns true or false
     */
    // @LogActions({isAsync: true})
    async activateOrDeactivateProduct(productReq: ProductRequest): Promise<ProductResponseModel> {
        try {
            const productExists = await this.getProductById(productReq.productId);
            if (productExists) {
                if (productReq.versionFlag !== productExists.versionFlag) {
                    throw new ProductResponseModel(false,10113, 'Someone updated the current Product information.Refresh and try again');
                } else {
                    
                        const productSatatus =  await this.productRepository.update(
                            { productId: productReq.productId },
                            { isActive: productReq.isActive,updatedUser: productReq.updatedUser });
                       
                        if (productExists.isActive) {
                            if (productSatatus.affected) {
                                const productResponse: ProductResponseModel = new ProductResponseModel(true, 10115, 'Product is de-activated successfully');
                                return productResponse;
                            } else {
                                throw new ProductResponseModel(false,10111, 'Product is already deactivated');
                            }
                        } else {
                            if (productSatatus.affected) {
                                const productResponse: ProductResponseModel = new ProductResponseModel(true, 10114, 'Product is activated successfully');
                                return productResponse;
                            } else {
                                throw new ProductResponseModel(false,10112, 'Product is already  activated');
                            }
                        }
                    // }
                }
            } else {
                throw new ProductResponseModel(false,99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }
    async getActiveProductById(productReq: ProductRequest): Promise<ProductResponseModel> {
        // const page: number = 1;
        try {
            //retrieves all companies
            console.log(productReq);
            const productId = productReq.productId;
            const productEntities: Product = await this.productRepository.findOne({
              where:{productId:productId}
              });
              console.log(productEntities);
              const productData: ProductDTO = this.productAdapter.convertEntityToDto(productEntities);
              if (productData) {
                  const response = new ProductResponseModel(true, 11101 , 'Product retrived Successfully',productData);
                  return response;
              }
              else{
                  throw new ProductResponseModel(false,11106,'Something went wrong');
              }
              // generating resposnse
              
          } catch (err) {
            throw err;
          }
    }

    async getProductById(productId: number): Promise<Product> {
    //  console.log(employeeId);
        const Response = await this.productRepository.findOne({
        where: {productId: productId},
        });
        // console.log(employeeResponse);
        if (Response) {
        return Response;
        } else {
        return null;
        }
    }
}
